import { FastlyImage, LazyImage } from '@components/common/image'
import { DIVERSE_TEACHER_STATS } from '@lib/data/teacher-lp'

const DiverseAndDynamic = () => (
  <>
    <div className="flex flex-col items-center justify-center mt-24 px-6 text-grey">
      <p className="font-700 text-4xl text-center md:text-left">
        A diverse and dynamic community of teachers
      </p>
      <LazyImage
        path="/images/teacher-lp/"
        name="line"
        className="w-24 md:w-32"
        alt="line image"
      />
    </div>
    <div className="flex flex-wrap  justify-around md:justify-center md:gap-16 px-6 md:px-10 container mx-auto mt-5 md:mt-12">
      {DIVERSE_TEACHER_STATS.map((item) => (
        <div
          key={item.title}
          className="relative flex flex-col items-center justify-center"
        >
          <FastlyImage
            src="/images/teacher-lp/diverse-and-dynamic/hexagon.png"
            height="250"
            width="220"
            alt="Hexagon"
          />
          <div className="absolute text-center mt-auto px-10">
            <span className="inline-block text-orange font-700 text-4xl">
              {item.stat}
            </span>
            <br />
            <span className="inline-block text-grey-800 font-600">
              {item.title}
            </span>
          </div>
        </div>
      ))}
    </div>
  </>
)

export default DiverseAndDynamic
